class responsivePagination {
  constructor(selector = '.pagination') {
    const pagination = document.querySelector( selector );

    if (!pagination) {
      return;
    }

    this.pagination = pagination;
    // Convert HTMLCollection to an array
    this.itemLength = this.pagination.getElementsByTagName( 'li' ).length;
    this.items = Array.from( this.pagination.getElementsByClassName( 'maybe-hide' ) );

    this.maybeHideItems();
    window.addEventListener('resize', this.maybeHideItems.bind(this));
    window.addEventListener('orientationchange', this.maybeHideItems.bind(this));
  }

  /**
   * Hide items when the screen is too small or the user is zoomed 400%;
   */
  maybeHideItems() {
      window.matchMedia('(resolution: 4dppx)').matches && this.itemLength > 5 ? this.hideItems() : this.showItems();
  }

  hideItems() {
    this.items.forEach(item => item.setAttribute('hidden', true));
  }

  showItems() {
    this.items.forEach(item => item.removeAttribute('hidden'));
  }
}

export default responsivePagination;
